import React from 'react';
import { ReactComponent as Minus } from '../../assets/icons/calculator/minus.svg';
import { ReactComponent as Plus } from '../../assets/icons/calculator/plus.svg';

import styles from './styles/counter.module.scss';

const BUTTON_ICON = {
  PLUS: <Plus />,
  MINUS: <Minus />,
};

export const Counter = ({
  value,
  onBlur = () => {},
  onChange,
  register = () => {},
  name,
  min = 1,
  max = Infinity,
  step = 1,
}) => {
  const handelInputBlur = (event) => {
    const newValue = Number(event.target.value || min);
    onBlur(newValue);
  };

  const handleReduce = () => {
    onChange(value - step);
  };

  const handleIncrease = () => {
    onChange(value >= max ? max : value + step);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    let resultCount = value;
    if (value < min) resultCount = min;
    if (value > max) resultCount = max;
    onChange(resultCount);
  };

  return (
    <div className={styles.counter}>
      <button
        type="button"
        className={styles.counter_button}
        disabled={value <= min}
        onClick={handleReduce}
      >
        {BUTTON_ICON['MINUS']}
      </button>
      <input
        type="number"
        {...register(name)}
        min={min}
        value={value}
        onBlur={handelInputBlur}
        onChange={handleChange}
        className={styles.counter_input}
      />
      <button
        type="button"
        className={styles.counter_button}
        onClick={handleIncrease}
        disabled={value >= max}
      >
        {BUTTON_ICON['PLUS']}
      </button>
    </div>
  );
};
